/*jshint esversion: 6 */
import Home from "./UI/home.vue";
import Users from "./UI/users.vue";
import Posts from "./UI/posts.vue";
import Translates from "./UI/translates.vue";
import Experts from "./UI/experts.vue";
import Extra from "./UI/extra.vue";
import Slides from "./UI/slides.vue";
import Backgrounds from "./UI/backgrounds.vue";
import Photos from "./UI/photos.vue";
import Videos from "./UI/videos.vue";
import library from "./UI/library.vue";
import Tutor from "../../components/tutor/tutor.vue";
export default [
    {
        path:"/",
        icon: 'home', 
        component: Home, 
        label: "Home" 
    },
    /*{
        path:"/users",
        icon: 'user', 
        component: Users, 
        label: "Пользователи" 
    },*//*
    {
        path:"/domains",
        icon: 'globe', 
        component: Users, 
        label: "Домены" 
    },*/
    /*{
        path:"/tutor",
        icon: 'globe', 
        component: Tutor, 
        label: "Тутор" 
    },*/
    {
        path:"/posts",
        icon: 'paperclip', 
        component: Posts, 
        label: "Публикации" 
    },
    {
        path:"/library",
        icon: 'book', 
        component: library, 
        label: "Библиотека" 
    },
    {
        path:"/translates",
        icon: 'exchange', 
        component: Translates, 
        label: "Переводы" 
    },
    {
        path:"/experts",
        icon: 'users', 
        component: Experts, 
        label: "Эксперты" 
    },/*
    {
        path:"/extra",
        icon: 'file-plus', 
        component: Extra, 
        label: "Разделы" 
    },*/
    {
        path:"/slides",
        icon: 'images', 
        component: Slides, 
        label: "Слайды" 
    },
    {
        path:"/photos",
        icon: 'images', 
        component: Photos, 
        label: "Фотографии" 
    },
    {
        path:"/videos",
        icon: 'video', 
        component: Videos, 
        label: "Видео" 
    },
    {
        path:"/backgrounds",
        icon: 'image',
        component: Backgrounds, 
        label: "Фоны"
    },
    {
        path:"/exit",
        icon: 'sign-out',
        label: "Выход"
    }
];


